import { SET_LIMIT, SET_SORT_BY } from "../actions/filterActions";

interface FilterState {
  limit: number;
  sortBy: string;
}

const initialState: FilterState = {
  limit: 10,
  sortBy: "Newest",
};

export const filterReducer = (
  state = initialState,
  action: any
): FilterState => {
  switch (action.type) {
    case SET_LIMIT:
      return { ...state, limit: action.payload };
    case SET_SORT_BY:
      return { ...state, sortBy: action.payload };
    default:
      return state;
  }
};
